<template>
    <div class="container">
        <div class="header">
            Upload Documents 
            <div class="cross" @click="closePopup()">
                <img src="@/assets/cross.svg" alt="cross"/>
            </div>
        </div>
        <div class="flex gap-10 w-full">
            <InpComponent
                v-if="neededDocuments.length"
                class="flex-1"
                label="Document Type"
                key_ref="doc_type"
                :value="document.doc_type"
                @inputChange="changeInput"
                type="options"
                :options="neededDocuments"
                :error="similarFile ? 'This file is already attached to the due diligence are you sure you want to re-submit is?' : ''"
            />
            <InpComponent v-if="[
                    'certified_true_copy_of_passport', 
                    'proof_of_address'
                ].includes(document.doc_type)"
                class="flex-1"
                label="Due Diligence Section "
                key_ref="due_diligence_id"
                :value="document.due_diligence_id"
                :options="dueDiligenceOptions"
                @inputChange="changeInput"
                type="options"
            />

        </div>
        <div>
            <div class="header-of-section">Comment</div>
            <CommentSection @changeinput="quillContent" class="markdown-content"/>
        </div>
        <div>
            <div class="header-of-section">Attach Files</div>
            <MultiFileUploader :single=true @sendFileInfo="getFiles" class="uploadfile" />
        </div>
        <div class="add-new-ticket-info flex gap-5">
            <button class="transparent cancel-btn" @click="closePopup()">Cancel</button>
            <button @click="uploadDueDiligenceDoc()">Upload</button>
        </div>
    </div>
</template>


<script setup>
    import { ref, defineEmits, defineProps, computed, onMounted } from 'vue'
    import { useStore } from 'vuex'
    import { useRoute } from 'vue-router'

    import InpComponent from './InpComponent.vue';
    import CommentSection from '@/views/CommentSection.vue';
    import MultiFileUploader from '@/components/MultifileUploader.vue';
    import API from '../api/index.js';

    const route = useRoute();
    const queryParams = computed( () => route.query )
    const viewingToken = ref(queryParams.value.token)

    const store = useStore();
    const dueDiligenceElements = computed(() => store.state.dueDiligenceElements);
    const kycFiles = computed(() => store.state.kyc_files);
    function getFileId(doc_type, element_id = undefined) {
        for (let file of kycFiles.value) {
            if (file.documentType === doc_type) {
                return file.id
            }
        }
    }
    const personFiles = [
        'certified_true_copy_of_passport',
        'proof_of_address',   
    ]

    const similarFile = computed(() => {
        if (!document.value.doc_type) return false;
        if (personFiles.includes(document.value.doc_type)) {
            console.log('fmfwkefmwewwf')
            return kycFiles.value.some(file => 
                file.documentType === document.value.doc_type && 
                file.dueDiligenceElement === document.value.due_diligence_id &&
                file.status != 'rejected' &&
                file.file
            );
        }
        else {
            return kycFiles.value.some(file => file.documentType === document.value.doc_type && file.status != 'rejected' && file.file);
        }
    })
    const dueDiligenceOptions = computed(() => {
        const options = [];
        for (let element of dueDiligenceElements.value) {
            if (element.type.value == 'company') {
                continue; // Skip company type elements
            }
            // if (['director', 'beneficiary', 'corporate_shareholder'].includes(element.type)) {
                let name = (element?.company_name?.new_value || element?.company_name?.value || element?.full_name?.new_value || element?.full_name?.value);
                options.push({
                    text: name,
                    value: element._id
                })
            // }
        }
        return options;
    })

    const neededDocuments = ref([]);

    const emit = defineEmits(['close', 'ticketInfoUpdate', 'loading'])
    const document = ref({
        doc_type: '',
        content: '',
        due_diligence_id: store.state?.dueDiligenceRecord?._id,
        token: viewingToken.value || null,
    })

    function handleFileChange(event) {
        const files = event.target.files || event.dataTransfer.files;
        if (files.length > 0) {
            selectedFile.value = files[0];
        }
        const file = selectedFile.value;
        file.filename = file.name;
        store.commit('updateFileById', {
            id: props.fileId, 
            updates: {
                file: file,
                new_file: true,
            }
        })
    }

    const fileList = ref([]);
    async function uploadDueDiligenceDoc() {

        if (fileList.value.length == 0) {
            store.dispatch('addNotification', {
                text: 'Please attach a file',
                type: 'error'
            })
            return
        }
        let response = await API.uploadDueDiligenceDoc(fileList.value[0], document.value);
        if (response.status == 'success') {
            store.dispatch('addNotification', {
                text: 'Document uploaded successfully',
                type: 'success'
            })
            store.state.kyc_files = [...store.state.kyc_files, response.file];
            emit('close')
        } else {
            store.dispatch('addNotification', {
                text: 'Error uploading document',
                type: 'error'
            })
        }
        // emit('ticketInfoUpdate', {ticket: document.value, files: fileList.value})
    }
    function quillContent(text) {
        document.value.content = text.text
    }
    function changeInput(event) {
        const event_type = event[0];
        const event_value = event[1];
        document.value[event_type] = event_value;
    }
    function getFiles(event){
        fileList.value = event;
    }
    function closePopup(){
        emit('close')
    }
    onMounted( () => {
        neededDocuments.value = [
            {text: 'Due Diligence Form', value: 'due_dil_form'},
            {text: 'Certificate of Incorporation', value: 'certofinc'},
            {text: 'Articles of Incorporation', value: 'article_if_incorp'},
            {text: 'Certificate Excerpt from Register', value: 'cert_excerpt_from_register'},
            {text: 'Register of Shareholders', value: 'register_of_shareholders'},
            {text: 'Director Register', value: 'director_register'},
            {text: 'Certificate Copy of Representative', value: 'cert_copy_of_representative'},
            {text: 'Structure Chart', value: 'structure_chart'},
            {text: 'Proof of Domain Ownership', value: 'proof_of_domain_ownership'},
            {text: 'Copy of License', value: 'copy_of_license'},
            {text: 'Privacy Policy', value: 'privacy_policy'},
            {text: 'Certified true copy of passport', value: 'certified_true_copy_of_passport'},
            {text: 'Proof of Address', value: 'proof_of_address'},
        ]
        for(let element of dueDiligenceElements.value){
            if (['director', 'beneficiary'].includes(element.type)){
                // neededDocuments.push({text: dueDiligenceElements[i].name, value: dueDiligenceElements[i].name})
            }
        }
    })
</script>


<style scoped lang="scss">
    .container {
        border-radius: .5rem;
        display: flex;
        flex-direction: column;
        width: 600px;
        border: 1px solid var(--border-color);
        min-height: 400px;
        padding: 20px;
        background-color: white;
    } 
    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        font-size: 1.6rem;
        font-weight: 700;
        line-height: 2rem;
        color: black;
    }
    .cancel-btn {
        margin-left: auto;
        margin-right: 10px;
    }
    .add-new-ticket-info {
        margin-top: 30px;
        button {
            width: fit-content;
            padding: 10px 30px;
        }
    }
    .red-text {
        color: red;
    }
    .cross {
        border-radius: 50%;
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
            cursor: pointer;
        }
        img {
            width: 20px;
            height: 20px;
        }
    }
    .ticket-details {
        font-size: 1.2rem;
        font-weight: 700;
        line-height: 1.5rem;
        color: black;
        padding-bottom: 20px;
        text-align: left;
    }
    .markdown-content {
        height: 200px;
        max-height: 200px;
        :nth-child(1) {
            text-align: left;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        }
    }
    .header-of-section {
        color: black;
        text-align: left;
        font-weight: 600;
        font-size: 16px;
    }

</style>